module.exports = __webpack_public_path__ + "img/logo-headline65x400.09cad081.png";